/* Personalised Car Mugs — Two-image gallery */

(() => {
  const SPECS_IMAGE =
    'https://cdn.shopify.com/s/files/1/0695/6852/8703/files/Mug_spec_image.png?v=1792524848';

  function initialiseGallery(gallery) {
    if (gallery.dataset.pcmInitialised === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const initialSlide = viewer.querySelector('li[data-media-id]');
    if (!initialSlide) return;

    gallery.dataset.pcmInitialised = 'true';

    // Create our own two-image display.
    const customGallery = document.createElement('div');
    customGallery.className = 'pcm-custom-gallery';

    customGallery.innerHTML = `
      <div class="pcm-main-image">
        <img class="pcm-displayed-image" alt="Selected vehicle mug">
      </div>

      <div class="pcm-thumbnails">
        <button
          type="button"
          class="pcm-thumbnail pcm-vehicle-thumbnail"
          aria-label="View selected vehicle mug"
          aria-pressed="true"
        >
          <img alt="Selected vehicle mug">
        </button>

        <button
          type="button"
          class="pcm-thumbnail pcm-specs-thumbnail"
          aria-label="View mug specifications"
          aria-pressed="false"
        >
          <img
            src="${SPECS_IMAGE}"
            alt="Mug specifications"
          >
        </button>
      </div>
    `;

    gallery.parentNode.insertBefore(customGallery, gallery);

    const mainImage = customGallery.querySelector('.pcm-displayed-image');

    const vehicleButton = customGallery.querySelector(
      '.pcm-vehicle-thumbnail'
    );

    const vehicleThumbnail = vehicleButton.querySelector('img');

    const specsButton = customGallery.querySelector(
      '.pcm-specs-thumbnail'
    );

    let vehicleImageUrl = '';
    let currentView = 'vehicle';

    function showImage(view) {
      currentView = view;

      mainImage.src =
        view === 'specs' ? SPECS_IMAGE : vehicleImageUrl;

      mainImage.alt =
        view === 'specs'
          ? '11oz ceramic and 14oz travel mug specifications'
          : 'Selected vehicle mug';

      vehicleButton.classList.toggle(
        'pcm-selected',
        view === 'vehicle'
      );

      specsButton.classList.toggle(
        'pcm-selected',
        view === 'specs'
      );

      vehicleButton.setAttribute(
        'aria-pressed',
        String(view === 'vehicle')
      );

      specsButton.setAttribute(
        'aria-pressed',
        String(view === 'specs')
      );
    }

    function getSelectedSlide() {
      const sectionId = gallery.id.replace('MediaGallery-', '');

      const variantPicker = document.querySelector(
        `variant-selects[data-section="${sectionId}"]`
      );

      const featuredId =
        variantPicker?.currentVariant?.featured_media?.id;

      if (featuredId) {
        const matchingSlide = Array.from(
          viewer.querySelectorAll('li[data-media-id]')
        ).find(
          (slide) =>
            slide.dataset.mediaId === `${sectionId}-${featuredId}`
        );

        if (matchingSlide) return matchingSlide;
      }

      return (
        viewer.querySelector('li[data-media-id].is-active') ||
        viewer.querySelector('li[data-media-id]')
      );
    }

    function updateVehicleImage(forceVehicleView = false) {
      const slide = getSelectedSlide();

      if (!slide) return;

      const image = slide.querySelector('img');

      if (!image) return;

      const newUrl = image.src;

      if (!newUrl) return;

      const changed = newUrl !== vehicleImageUrl;

      vehicleImageUrl = newUrl;
      vehicleThumbnail.src = newUrl;

      if (
        changed ||
        forceVehicleView ||
        currentView === 'vehicle'
      ) {
        showImage('vehicle');
      }
    }

    // Click the vehicle thumbnail.
    vehicleButton.addEventListener('click', () => {
      showImage('vehicle');
    });

    // Click the specifications thumbnail.
    specsButton.addEventListener('click', () => {
      showImage('specs');
    });

    // Watch for Shopify updating the gallery.
    const observer = new MutationObserver(() => {
      updateVehicleImage();
    });

    observer.observe(viewer, {
      childList: true,
      subtree: true
    });

    // Update the mug when a different colour is selected.
    document.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects')) return;

      showImage('vehicle');

      setTimeout(() => {
        updateVehicleImage(true);
      }, 250);

      setTimeout(() => {
        updateVehicleImage(true);
      }, 750);
    });

    // Keep Shopify's original gallery available to its
    // JavaScript while hiding it from customers.
    gallery.classList.add('pcm-original-gallery');

    updateVehicleImage(true);
  }

  function initialiseAll() {
    document
      .querySelectorAll('media-gallery')
      .forEach(initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAll
    );
  } else {
    initialiseAll();
  }

  // Support Shopify's theme editor.
  document.addEventListener(
    'shopify:section:load',
    initialiseAll
  );
})();